import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const updateComment: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { storeApi },
) =>
  action$.pipe(
    ofType(actions.UPDATE_COMMENT),
    switchMap(({ payload: { storeId, comment } }) => {
      return storeApi.updateComment(storeId, comment).pipe(
        switchMap(() => of(actions.commentUpdateSuccess(comment))),
        catchError(error => of(actions.storeFailed(error))),
      );
    }),
  );



// WEBPACK FOOTER //
// ./src/scenes/Store/services/epics/updateComment.ts